import React from 'react';
import CourseCardV2 from 'Components/CourseCardV2/CourseCardV2';
import { EmptyText } from '../../../Dashboard.styled';
import { Grid } from './PendingList.styled';
import type { PendingCourseVM } from '../../../hooks/useDashboardPage';

export interface PendingListProps {
  items: PendingCourseVM[];
  emptyText: string;
  onItemClick: (id: string) => void;
}

export default function PendingList({ items, emptyText, onItemClick }: PendingListProps) {
  if (items.length === 0) return <EmptyText>{emptyText}</EmptyText>;

  return (
    <Grid>
      {items.map(item => (
        <CourseCardV2
          key={item.id}
          name={item.name}
          thumbnailUrl={item.thumbnailUrl}
          modulesText={item.modulesText}
          dueText={item.dueText}
          onClick={() => onItemClick(item.id)}
        />
      ))}
    </Grid>
  );
}
